import { createSlice } from "@reduxjs/toolkit";

const companySlice = createSlice({
  name: "company",
  initialState: {
    company: [],
    companyDetails: {},
    eachCompanyDetails: {},
    eachUserDetails: {},
    search: [],
    allCompany: [],
    companyIsLoading: false,
    companyDetailsLoading: false,
    userDetailsLoading: false,
    isSearchLoading: false,
    companyPermission: {},
  },
  reducers: {
    setCompanyPerMission: (state, action) => {
      state.companyPermission = action.payload.companyPermission;
    },
    setisSearchLoading: (state, action) => {
      state.isSearchLoading = action.payload.isSearchLoading;
    },
    setIsCompanyLoading: (state, action) => {
      state.companyIsLoading = action.payload.companyIsLoading;
    },
    setCompanyDetailsLoading: (state, action) => {
      state.companyDetailsLoading = action.payload.companyDetailsLoading;
    },
    setUserDetailsLoading: (state, action) => {
      state.userDetailsLoading = action.payload.userDetailsLoading;
    },

    getAllCompany(state, action) {
      state.allCompany = action.payload.allCompany;
    },
    getCompany(state, action) {
      state.companyDetails = action.payload.companyDetails;
    },
    getEachCompany(state, action) {
      state.eachCompanyDetails = action.payload.companyDetails;
    },
    getSearch(state, action) {
      state.search = action.payload.search;
    },
    getEachUser(state, action) {
      state.eachUserDetails = action.payload.userDetails;
    },
  },
});

export const {
  setIsCompanyLoading,
  setCompanyDetailsLoading,
  setUserDetailsLoading,
  getAllCompany,
  getCompany,
  getSearch,
  getEachCompany,
  getEachUser,
  setisSearchLoading,
  setCompanyPerMission,
} = companySlice.actions;
export const companyReducer = companySlice.reducer;
